import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('webhooks'),
  rootKey: 'webhook',
});



// WEBPACK FOOTER //
// ./app/models/webhook.js